import { IconButton } from "@circleco/compass/components/IconButton";
import { Tooltip } from "@circleco/compass/components/Tooltip";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { MarkAsReadButton } from "@/react/components/Modals/MessagingModalCompass/LeftSidebar/MarkAsReadButton";

import { RightActionBlockHeader } from "../RightActionBlockHeader";

export const Header = () => {
  const navigate = useNavigate();

  return (
    <RightActionBlockHeader
      title={t("header_v3.direct_messages")}
      actions={
        <>
          <MarkAsReadButton />
          <Tooltip content={t("new_message")}>
            <IconButton
              variant="ghost"
              icon="plus"
              size="md"
              onClick={() =>
                void navigate({
                  to: "/messages/$uuid",
                  params: { uuid: "new" },
                })
              }
              data-testid="new-message"
              aria-label={t("new_message")}
            />
          </Tooltip>
        </>
      }
    />
  );
};
